<template>
    <div class="cs-emailVerification" v-if="isShown">
      <div :class="!!userInfo.uid ? 'cs3-trial-emailVerificationProfile' : 'cs3-trial-emailVerificationProfileUnknown'">
        
        <div class="cs3-trial-emailVerificationProfile__greetings">
          {{dictionaryFile.Hi}} <span class="cs3-trial-emailVerificationProfile__greetingsUsername">{{username}}</span>!
        </div>
        <div :class="!!userInfo.uid ?'cs3-trial-emailVerificationProfile__sendingInfo' : 'cs3-trial-emailVerificationProfileUnknown__sendingInfo'" v-html="dictionaryFile.weAreSendingTheTrial">
        </div>
        <ProfileFeed v-if="userInfo && userInfo.medias && userInfo.medias.length !== 0" :dictionaryFile="dictionaryFile" :userInfo="userInfo" />
      </div>
      <div class="cs3-trial-emailVerificationInstruction">
        {{dictionaryFile.emailVerificationInstruction1}} <span class="cs3-trial-emailVerificationInstruction__email">{{email}} </span> {{dictionaryFile.emailVerificationInstruction2}} 
        <strong>{{dictionaryFile.emailVerificationInstruction3}}</strong> 
        {{dictionaryFile.emailVerificationInstruction4}}
      </div>
      <div class="cs3-trial-emailVerificationCodeError" v-if="isEmailCodeWrong">
        {{dictionaryFile.errors.emailCodeWrong}}
      </div>
      <div class="cs3-trial-emailVerificationInputContainer">
        <input type="number" :placeholder="0" class="cs3-trial-emailVerificationInput" :class="showEmailInputError ? 'cs3-trial-emailVerificationInputError': ''" v-for="(emailCodeInput, index) in emailCodeInputs" :key="`emailCodeInput${index}`"
          v-model="emailCodeInputs[index][0]"
          v-on:input="onEmailVericationInput($event,index)">
      </div>
      <div class="cs3-trial-emailVerificationContinueButtonContainer">
      <button class="cs3-trial-emailVerificationContinueButton" 
      :class="canEmailVerificationContinue()? 'cs3-trial-emailVerificationContinueButtonFull' : ''" v-on:click="canEmailVerificationContinue() ? verifyEmailCode() : ''">
        {{dictionaryFile.confirmAndContinue}}
      </button>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import {shakeElementsByClass} from "../../assets/js/csService";
import {API_URL,VERIFY_EMAIL_VERIFICATION_ENDPOINT, getEmailVerificationRequestBody, DEFAULT_HEADER} from "../../assets/js/api";
import ProfileFeed from "../profileFeed/profileFeed.vue";
export default{
    name: 'EmailVerification',
    props: {
        isShown: {
            type: Boolean,
            required: true
        },
        dictionaryFile: {
            type: Object,
            required: true
        },
        userInfo: {
            type: Object,
            required: false
        },
        username: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        },
    },
    components: {
        ProfileFeed
    },
    emits: [
        'beginVerification', 'failedEmailVerification', 'correctEmailCode'
    ],
    data: function(){
        return {
            isEmailCodeWrong: false,
            emailCodeInputs: [[null,false],[null,false],[null,false],[null,false]],
            showEmailInputError: false,
        }
    },
    methods: {
        onEmailVericationInput(evt, index){
          if(this.showEmailInputError){
            this.showEmailInputError = !this.showEmailInputError;
          }
          if(isFinite(evt.data)){
              this.emailCodeInputs[index][0] = evt.data;
              this.emailCodeInputs[index][1] = true;
              if(index < this.emailCodeInputs.length -1 ){
                  evt.target.nextElementSibling.focus();
              }
          }
        },
        canEmailVerificationContinue(){
            return this.emailCodeInputs.every((emailCodeInput) => emailCodeInput[1]);
        },
        getCurrentEmailCode(){
            let emailCode = '';
            this.emailCodeInputs.forEach((element) => emailCode += element[0]);
            return emailCode;
        },
        async verifyEmailCode(){
          this.$emit('beginVerification');
          await axios.post(`${API_URL}${VERIFY_EMAIL_VERIFICATION_ENDPOINT}`, getEmailVerificationRequestBody(this.userInfo.uid, this.email, this.getCurrentEmailCode()), DEFAULT_HEADER ).then((res) => {
              if(res.data.status == 1){
                  this.$emit("correctEmailCode");
              } else {
                  this.$emit("failedEmailVerification"); 
                  this.isEmailCodeWrong = true;
                  this.showEmailInputError = true;
                  setTimeout(() => shakeElementsByClass('cs3-trial-emailVerificationInput'), 200);
              }
          }).catch((err)=>{
              console.error(err);
              this.$emit("failedEmailVerification");
          })
        }
    }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.cs3-trial-emailVerificationProfile {
  padding: 0 20px;
  text-align: center;
  margin: 15px 0;
}

.cs3-trial-emailVerificationProfileUnknown {
  display: grid;
  grid-template-rows: 0.5fr 1fr;
  padding: 0 20px;
  text-align: center;
  grid-column-gap: 10px;
  margin: 15px 0;
}

.cs3-trial-emailVerificationProfile__photo {
  width: 90px;
  height: 90px;
  border-radius: 20px
}

.cs3-trial-emailVerificationProfile__greetings {
  text-align: center;
  font-size: 16px;
  color: black;
}

.cs3-trial-emailVerificationProfile__greetingsUsername {
  color: #AA61D8;
}

.cs3-trial-emailVerificationProfile__sendingInfo {
  color: #696969;
  font-weight: 500;
  font-size: 13px;
}

.cs3-trial-emailVerificationProfileUnknown__sendingInfo {
  color: #696969;
  font-weight: 500;
  font-size: 13px;
}

.cs3-trial-emailVerificationCodeError {
  color: rgba(241, 91, 101, 1);
  font-size: 13px;
  margin-bottom: 10px
}

.cs3-trial-emailVerificationProfile__sendingInfo, .cs3-trial-emailVerificationInstruction {
  font-size: 13px
}

.cs3-trial-emailVerificationInstruction {
  margin: 10px;
  padding: 0 10px;
}

.cs3-trial-emailVerificationInstruction__email {
  color: #AA61D8;
}

.cs3-trial-emailVerificationInputContainer {
display: grid;
grid-template-columns: repeat(4,1fr);
padding: 0 10px;
margin: 0 auto;
justify-items: center;
}

.cs3-trial-emailVerificationInput {
-webkit-appearance: none;
margin: 5px 0;
padding: 10px;
width: 100%;
max-width: 70px;
height: 90px;
color: rgba(84, 184, 222, 1);
background: #54B8DE73;
border: 2px solid #54B8DE;
outline: none;
font-size: 80px;
text-align: center;
font-weight: 400;
border-radius: 20px;
transition: background 0.5s;
}

.cs3-trial-emailVerificationInputError {
  background: rgba(241, 91, 101, 0.33); 
  outline: 0;
  border-color: rgba(241, 91, 101, 1);
  color: #F15B65
}

.cs3-trial-emailVerificationInput:focus:not(.cs3-trial-emailVerificationInputError) {
  background: #54B8DE;
  transition: background 0.5s;
  color: white;
  border-color: #54B8DE;
}

.cs3-trial-emailVerificationInput::placeholder {
  color: white;
}

.cs3-trial-emailVerificationContinueButtonContainer {
  padding: 0 20px;
}

.cs3-trial-emailVerificationContinueButton {
  background: none;
  border: 2px solid #54B8DE;
  color: #54B8DE;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  border-radius: 25px;
  padding: 7px 20px;
  margin: 10px 0 15px;
  cursor: not-allowed;
}

.cs3-trial-emailVerificationContinueButtonFull {
  color: #fff;
  background: #54B8DE;
  cursor: pointer;
}


</style>